import Result1 from '../assets/images/1.png';
import Result2 from '../assets/images/2.png';
import Result3 from '../assets/images/3.png';
import Result4 from '../assets/images/4.png';
import Result5 from '../assets/images/5.png';
import Result6 from '../assets/images/6.png';
import Result7 from '../assets/images/7.png';
import TrueResult1 from '../assets/images/result1.png';
import TrueResult2 from '../assets/images/result2.png';
import TrueResult3 from '../assets/images/result3.png';
import TrueResult4 from '../assets/images/result4.png';
import TrueResult5 from '../assets/images/result5.png';
import TrueResult6 from '../assets/images/result6.png';

export const RESULT_IMAGES = [
  Result1,
  Result2,
  Result3,
  Result4,
  Result5,
  Result6,
  Result7,
];

export const TRUE_RESULT_IMAGES = [
  TrueResult1,
  TrueResult2,
  TrueResult3,
  TrueResult4,
  TrueResult5,
  TrueResult6,
];
